import React from 'react';
export function StickyCTA() {
  return <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 p-3 md:hidden z-50" data-id="element-71">
      <a href="https://getpurenutra.co/products/purenutra%C2%AE-10-1-alpha-gummies" className="block w-full py-3 bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-lg text-center text-lg transition-colors duration-200 shadow-md" data-id="element-72">
        CLAIM YOUR ALPHA GUMMIES NOW
      </a>
    </div>;
}